import React from "react";
import IngredientSearch from "./IngredientSearch";
import ShoppingList from "./ShoppingList";
import "../styles/Pantry.css";
import ingredients from "../data/ingredients";
import { supabase } from "../supabaseClient";
import { useShoppingList } from "../context/ShoppingListProvider";

interface ShoppingItem {
  id: string;
  name: string;
  label: string;
  category: string;
}

const ShoppingListView: React.FC = () => {
  const { shoppingItems, setShoppingItems } = useShoppingList();

  const handleAddIngredient = (ingredient: {
    label: string;
    value: string;
  }) => {
    const exists = shoppingItems.some(
      (item) => item.name.toLowerCase() === ingredient.label.toLowerCase()
    );
    if (!exists) {
      const matching = ingredients.find(
        (i) => i.name.toLowerCase() === ingredient.label.toLowerCase()
      );
      const category = matching?.category || "Muu";
      const label = category.toLowerCase().replace(/\s/g, "-");
      const newItem: ShoppingItem = {
        id: crypto.randomUUID(),
        name: ingredient.label,
        category,
        label,
      };
      setShoppingItems((prev) => [...prev, newItem]);
    }
  };

  const handleRemove = async (id: string) => {
    // 🔴 Poista Supabasesta
    const { error } = await supabase
      .from("shopping_list_items")
      .delete()
      .eq("id", id);
    if (error) {
      console.error("Virhe poistettaessa Supabasesta:", error);
    }

    // 🟢 Poista local state:sta
    setShoppingItems((prev) => prev.filter((item) => item.id !== id));
  };

  const handleClearAll = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return;

    const { error } = await supabase
      .from("shopping_list_items")
      .delete()
      .eq("user_id", user.id);

    if (error) {
      console.error("Virhe kaikkien poistossa:", error);
    } else {
      setShoppingItems([]);
    }
  };

  return (
    <div className="food-storage-wrapper">
      <div className="ingredient-search-container">
        <IngredientSearch onAddIngredient={handleAddIngredient} />
      </div>

      <div className="food-storage-container">
        <ShoppingList
          items={shoppingItems}
          onRemove={handleRemove}
          onClearAll={handleClearAll}
        />
      </div>
    </div>
  );
};

export default ShoppingListView;
